import React, { Component } from "react";
import { connect } from "react-redux";
import { LoaderButton, IconLabel } from "ctia-ui";
import { withdrawRequest } from "actions/requestCyber";
import { clearRequests } from "actions/requests";
import {
  fetchBatteryForApproveRequests,
  approveBatteryRequest
} from "actions/battery/batteryRequests";
import ModalConfirm from "components/ModalConfirm/index";

class BatteryApproveButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showWithdrawnConfirm: false,
      showApproveConfirm: false,
      isLoading: false,
      isFormValid: true
    };
  }

  onApprove = () => {
    this.setState({ isLoading: true });
    const {
      approveBatteryRequest,
      fetchBatteryForApproveRequests,
      request,
      certType,
      withdraw = false
    } = this.props;

    const approved = !withdraw;

    approveBatteryRequest(request, approved, certType)
      .then(fetchBatteryForApproveRequests)
      .then(() => this.closeModal);
  };

  onWithdraw = () => {
    const { id, certType } = this.props;

    // withdraw reason
    const reason = document.getElementById("reasonRef").value;

    if (reason.length < 5) {
      this.setState({ isFormValid: false });
    } else {
      this.setState({ isLoading: true });
      this.props.withdrawRequest(id, reason, this.clearAndFetch, certType);
    }
  };

  clearAndFetch = () => {
    this.props.clearRequests();
    this.props.fetchBatteryForApproveRequests();
  };

  showWithdrawnModal = () => this.setState({ showWithdrawnConfirm: true });
  showApproveModal = () => this.setState({ showApproveConfirm: true });

  closeModal = () => {
    this.setState({
      showWithdrawnConfirm: false,
      showApproveConfirm: false,
      isLoading: false
    });
  };

  getStyleParams = withdraw => {
    return {
      btnStyle: withdraw ? "danger" : "success",
      btnText: withdraw ? "Withdraw" : "Approve",
      approved: !withdraw
    };
  };

  onValidate = value => {
    this.setState({ isFormValid: value.length > 4 });
  };

  render() {
    const { withdraw = false, request } = this.props;
    const params = this.getStyleParams(withdraw);

    const modalHandler = withdraw
      ? this.showWithdrawnModal
      : this.showApproveModal;

    const renderButtonIcon = () => {
      const icon = withdraw ? "ban" : "check";
      return <IconLabel label={params.btnText} awesomeIcon={icon} />;
    };

    const isSAR = request.manufsite.id > 0;
    const withdrawType = isSAR ? "withdrawReasonSAR" : "withdrawReason";
    const approveType = isSAR ? "approveSAR" : "approve";

    return [
      <LoaderButton
        bsStyle={params.btnStyle}
        bsSize="xsmall"
        text={renderButtonIcon()}
        className="button-right-offset"
        onClick={modalHandler}
        key={1}
      />,
      <ModalConfirm
        type={withdrawType}
        show={this.state.showWithdrawnConfirm}
        onHide={this.closeModal}
        onHandle={this.onWithdraw}
        requestData={request}
        isLoading={this.state.isLoading}
        isFormValid={this.state.isFormValid}
        onValidate={this.onValidate}
        key={2}
      />,
      <ModalConfirm
        type={approveType}
        show={this.state.showApproveConfirm}
        onHide={this.closeModal}
        onHandle={this.onApprove}
        requestData={request}
        isLoading={this.state.isLoading}
        key={3}
      />
    ];
  }
}

export default connect(null, {
  approveBatteryRequest,
  withdrawRequest,
  fetchBatteryForApproveRequests,
  clearRequests
})(BatteryApproveButton);
